module.exports = "<h1 matDialogTitle>{{confirmHead}}</h1>\n<div mat-dialog-content>{{confirmMessage}}</div>\n<div mat-dialog-actions class=\"pt-24 btn\">\n    <button mat-raised-button class=\"mat-accent mr-16\" [ngClass]=\"{'warn' : confirmOkText == 'Delete'}\"\n        (click)=\"dialogRef.close(true)\">\n        {{confirmOkText}}\n    </button>\n    <button mat-button (click)=\"dialogRef.close(false)\">\n        {{confirmCancelText}}\n    </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/core/components/confirm-dialog/confirm-dialog.component.html
// module id = ../../../../../src/app/core/components/confirm-dialog/confirm-dialog.component.html
// module chunks = main